module.exports = __webpack_public_path__ + "static/media/four-dots.8590526a.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/form/Type/four-dots.svg
 ** module id = 191
 ** module chunks = 0
 **/